module.exports = __webpack_public_path__ + "img/auotexc.000fc3f0.png";